import Model from './Model';

export default class extends Model {
  get() {
    let url = '/trips?' + this.getParamsAsQueryParam();
    return this.getPromise(url);
  }
}
